import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

const tableBodyVariants = tv({
  base: "bg-surface text-content",
});

export const TableBody = ({ className, ...props }: ComponentProps<"tbody">) => {
  return <tbody className={tableBodyVariants({ className })} {...props} />;
};
